/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './ad-unit-size-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-ad-unit-size-modal',
  template,
  styles: [`
    .ad-unit-size-preview-scroll {
      max-width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  `]
})
export class AdUnitSizeModalComponent implements OnInit {
  minWidth = 0;
  minHeight = 0;
  width = 0;
  height = 0;
  containerWidth = 0;
  containerHeight = 0;

  constructor(public bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.containerWidth = Math.max(this.minWidth, this.width) + 15;
    this.containerHeight = Math.max(this.minHeight, this.height) + 3;
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
